import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4872F4',
    },
  },
  typography: {
    fontFamily: 'nunitosemibold',
  },
});

export default theme;
